import {EDITAR_INFORMACOES} from '../constants/constants'
import {Map} from 'immutable';

export default (
    informacoesState = Map({
        nome : 'Caminho do Parque',
        telefone : ["(75) 98821-0124", "(75) 98821 5305"],
        endereco : 'Rua Rio Branco, 93, Centro, Amargosa - BA'
    }), action) =>{

    switch(action.type){
        case EDITAR_INFORMACOES:
            let {nome, telefones, endereco} = action
            console.log('>>>>>>>>>>>>>>>>>>>>>case EDITAR_INFORMACOES:', action)
            return informacoesState
                    .set('nome', nome)
                    .set('telefone',telefones)
                    .set('endereco', endereco);
        
    }
    return informacoesState;
}


// WEBPACK FOOTER //
// ./src/reducers/informacoes.js